import React from 'react'

import StarIcon from 'app/assets/icons/star.svg'
import Stack from 'app/components/base/Stack'
import Text, { TextProps } from 'app/components/base/Text'

type UserRatingProps = {
  rating?: number
  textColor?: TextProps['color']
  type?: 'primary' | 'secondary'
}

const UserRating = ({
  rating,
  textColor = 'text.primary',
  type = 'primary'
}: UserRatingProps) => {
  const isPrimary = type === 'primary'

  if (!rating) return null

  return (
    <Stack
      direction="row"
      spacing={isPrimary ? 1 : 0.5}
      sx={{ alignItems: 'center' }}
    >
      <StarIcon />

      {isPrimary ? (
        <Text
          variant="subtitle2"
          color={textColor}
          sx={{
            fontWeight: 600,
            fontFamily: 'Nunito'
          }}
        >
          {rating}
        </Text>
      ) : (
        <Text variant="subtitle1" color={textColor}>
          {rating}
        </Text>
      )}
    </Stack>
  )
}

export default UserRating
